import { Box, Typography } from '@mui/material';
import { useDropzone } from 'react-dropzone';
import zeplinColor from '../../../theme/Color';

export default function CustomDragnDrop({ onDrop }: { onDrop: (acceptedFile: any) => void }) {
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    maxSize: 50 * 1024 * 1024,
    accept: {
      'application/pdf': ['.pdf'],
      'image/jpeg': ['.jpeg'],
      'image/jpg': ['.jpg'],
      'image/png': ['.png'],
      'image/gif': ['.gif'],
      'image/webp': ['.webp'],
      'image/svg+xml': ['.svg'],
      'video/mp4': ['.mp4', '.m4v'],
      'video/webm': ['.webm'],
      'video/quicktime': ['.mov', '.qt'],
      'video/x-msvideo': ['.avi'],
      'video/mp2t': ['.ts', '.mts', '.m2ts'],
      'video/ogg': ['.ogv'],
      'video/x-ms-wmv': ['.wmv'],
    },
  });

  const DragNDropDescription = isDragActive
    ? 'Drop the files here ...'
    : 'Drag and drop your file here or click to select files';

  return (
    <div
      style={{
        borderStyle: 'dashed',
        borderWidth: '1px',
        borderColor: zeplinColor.Neutral6,
        backgroundColor: zeplinColor.Neutral1,
        height: '155px',
        borderRadius: '14px',
        width: '100%',
      }}
      {...getRootProps({ className: 'dropzone upload-btn' })}
    >
      <input {...getInputProps()} />
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%',
          flexDirection: 'column',
        }}
      >
        <img
          width={'24px'}
          height={'24px'}
          src={'/assets/upload.svg'}
          alt='logo'
          style={{ objectFit: 'fill' }}
        />

        <Typography
          variant='responsiveBody2'
          sx={{
            marginTop: '24px',
          }}
        >
          {DragNDropDescription}
        </Typography>
        <Typography
          variant='responsiveLabel1'
          color={zeplinColor.Neutral8}
          sx={{
            marginTop: '8px',
          }}
        >
          Max file size: 50MB | Support format: pdf, jpg, png, gif, webp, svg
        </Typography>
      </Box>
    </div>
  );
}
